import { render, staticRenderFns } from "./m-deep-badge-gold.vue?vue&type=template&id=27f46550&scoped=true&"
import script from "./m-deep-badge-gold.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-deep-badge-gold.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-deep-badge-gold.vue?vue&type=style&index=0&id=27f46550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f46550",
  null
  
)

export default component.exports